import { createContext } from 'react'

type TypeContext = {
  floatingRelative: HTMLDivElement | null
  opened: boolean
}

export type DropdownContextValue = [TypeContext, React.Dispatch<React.SetStateAction<TypeContext>>]

export const DropdownContext = createContext<DropdownContextValue>([
  { floatingRelative: null, opened: false },
  () => {},
])
